import React, { forwardRef, memo } from "react";
import { HStack } from "@chakra-ui/react";
import ComposeQuillBold from "./compose-quill-bold";
import { IQuillFormats } from "modules/quill/use-quill";
import ComposeQuillItalic from "./compose-quill-italic";
import ComposeQuillUnderline from "./compose-quill-underline";
import ComposeQuillStrikethrough from "./compose-quill-strikethrough";
import ComposeQuillLink from "./compose-quill-link";
import ComposeQuillBulletList from "./compose-quill-bullet-list";
import ComposeQuillOrderedList from "./compose-quill-ordered-list";
import ComposeQuillTextColorSelector from "./compose-quill-text-color-selector";
import ComposeQuillTextBackgroundColorSelector from "./compose-quill-text-background-color-selector";

interface IProps {
  format: (name: string, value: any) => void;
  insertLink: (url: string) => void;
  activeFormats: IQuillFormats;
}

const ComposeQuillToolbar = forwardRef<HTMLDivElement, IProps>(
  ({ format, insertLink, activeFormats }, ref) => (
    <HStack ref={ref} minH="24px" spacing={3}>
      <ComposeQuillBold format={format} activeFormats={activeFormats} />
      <ComposeQuillItalic format={format} activeFormats={activeFormats} />
      <ComposeQuillUnderline format={format} activeFormats={activeFormats} />
      <ComposeQuillStrikethrough
        format={format}
        activeFormats={activeFormats}
      />
      <ComposeQuillLink
        format={format}
        insertLink={insertLink}
        activeFormats={activeFormats}
      />
      <ComposeQuillBulletList format={format} activeFormats={activeFormats} />
      <ComposeQuillOrderedList format={format} activeFormats={activeFormats} />
      <ComposeQuillTextColorSelector
        format={format}
        activeFormats={activeFormats}
      />
      <ComposeQuillTextBackgroundColorSelector
        format={format}
        activeFormats={activeFormats}
      />
    </HStack>
  ),
);

ComposeQuillToolbar.displayName = "ComposeQuillToolbar";

export default memo(ComposeQuillToolbar);
